import { FC } from 'react';
import { PageHeader } from 'ui/pageHeader';
import { QueryContextProvider } from '../context';
import { SelectionContextProvider } from '../context/SelectionContextProvider';
import { SavedViewsTable } from './SavedViewsTable';

export const TEXT = {
  HEADER: 'Saved views',
};

export const SavedViewsIndex: FC = () => (
  <>
    <SelectionContextProvider>
      <QueryContextProvider>
        <PageHeader
          documentTitle={'Saved views'}
          breadcrumb={{ content: 'Messaging Insights', href: '/messagingInsights' }}
        >
          {TEXT.HEADER}
        </PageHeader>
        <SavedViewsTable />
      </QueryContextProvider>
    </SelectionContextProvider>
  </>
);

export default SavedViewsIndex;
